import { render, staticRenderFns } from "./LawyerOffice.vue?vue&type=template&id=cc5c8864&scoped=true"
import script from "./LawyerOffice.vue?vue&type=script&lang=js"
export * from "./LawyerOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5c8864",
  null
  
)

export default component.exports